'use client';

import { c as _c } from "react/compiler-runtime";
import { Popover } from '@base-ui/react/popover';
import { type ReactNode, useState } from 'react';
import { SiteSelectorWithPopoverBackdrop } from '@/components/SiteSelector/SiteSelectorWithPopoverBackdrop';
import { VisualSiteSelector } from '@/components/VisualSiteSelector/VisualSiteSelector';
import { UpTriangleIcon } from '@/components/icons/UpTriangleIcon';
import { type SiteSlugType, isFirstTimeVisit, setPreferredSiteCode } from '@/lib/preferredSite';
export type SiteSelectorWithPopOverProps = {
  children: ReactNode;
  siteSlug?: string;
  localeSlug?: string;
};
export function SiteSelectorWithPopOver(t0) {
  const $ = _c(13);
  const {
    children,
    siteSlug,
    localeSlug: t1
  } = t0;
  const localeSlug = t1 === undefined ? "en" : t1;
  const [open, setOpen] = useState(isFirstTimeVisit);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOpen(false);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleOpenChange = t2;
  let t3;
  if ($[1] !== children) {
    t3 = <Popover.Trigger id="site-selector-popover">{children}</Popover.Trigger>;
    $[1] = children;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SiteSelectorWithPopoverBackdrop />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Popover.Arrow className="hidden lg:block data-[side=bottom]:top-[-8px] data-[side=left]:right-[-13px] data-[side=left]:rotate-90 data-[side=right]:left-[-13px] data-[side=right]:-rotate-90 data-[side=top]:bottom-[-8px] data-[side=top]:rotate-180"><UpTriangleIcon /></Popover.Arrow>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = selectedSiteSlug => {
      handleOpenChange();
      setPreferredSiteCode(selectedSiteSlug as SiteSlugType);
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== localeSlug || $[7] !== siteSlug) {
    t7 = <Popover.Portal>{t4}<Popover.Positioner sideOffset={10}><Popover.Popup className="origin-[var(--transform-origin)] transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0">{t5}<div className="relative"><div className="fixed lg:static w-[340px] top-[calc(100vh-calc(var(--spacing)*60))] right-[calc(calc((100vw-340px)/2)-58px)]"><VisualSiteSelector siteSlug={siteSlug} localeSlug={localeSlug} onClickAction={t6} /></div></div></Popover.Popup></Popover.Positioner></Popover.Portal>;
    $[6] = localeSlug;
    $[7] = siteSlug;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== open || $[10] !== t3 || $[11] !== t7) {
    t8 = <Popover.Root open={open} onOpenChange={handleOpenChange}>{t3}{t7}</Popover.Root>;
    $[9] = open;
    $[10] = t3;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}